<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      class="pb-0"
      maxwidth-container="960px"
      rodape
    >
      <ErrorServidor v-if="error" />
      <template v-else>
        <v-breadcrumbs
          v-if="$vuetify.breakpoint.mdAndUp"
          :items="menus"
          class="pl-0 mt-6 pb-0"
        >
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>

        <TituloPagina :titulo="tituloPagina" class="mt-8 mt-md-9" />

        <p class="primary--text mt-6 body-2">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Proin placerat ex nec metus mattis, eu finibus mauris sollicitudin.
          Sed tincidunt tortor quis lectus pulvinar pharetra.
          Pellentesque vulputate, libero vel placerat bibendum,
          massa odio fermentum
        </p>

        <h2 class="display-1 primary--text text-center pt-5">
          <v-skeleton-loader
            v-if="loading"
            class="mx-auto"
            max-width="150"
            type="text"
          />

          <template v-else>
            <strong>{{ score }} pontos</strong>
          </template>
        </h2>
        <p class="text-uppercase primary--text text-center pt-3">
          Com essa pontuação, você pode:
        </p>
        <div class="px-2">
          <ul class="row">
            <li
              v-for="k in 6"
              :key="k"
              class="col-md-6 col-12 primary--text pl-0"
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </li>
          </ul>
        </div>
      </template>
    </InternaMain>
    <Rodape />
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import Rodape from '@/components/Rodape.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';
import api from '@/api';

export default {
  name: 'MeusPontos',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    TituloPagina,
    Rodape,
    ErrorServidor,
  },

  data() {
    return {
      error: false,
      loading: false,
      score: 0,
      tituloPagina: 'Meus pontos',
    };
  },

  computed: {
    menus() {
      return [
        {
          text: 'Minhas Compras',
          disabled: false,
          to: {
            name: 'minhas-compras',
          },
        },
        {
          text: 'Meus pontos',
          disabled: true,
        },
      ];
    },
  },

  created() {
    this.scoreConsumidor();
  },

  methods: {
    async scoreConsumidor() {
      this.loading = true;

      await api.get('/consumer_score')
        .then(({ data }) => {
          this.score = data.score ? data.score : 0;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

};

</script>
